import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Global floating BACK button — floats at the bottom-left corner on all
 * screen sizes and stays in view while scrolling. Hidden on the landing page.
 */
export default function NavControls() {
    const navigate = useNavigate();
    const location = useLocation();
    const onLanding = location.pathname === "/";

    if (onLanding) return null;

    return (
        <div className="fixed z-[10050] left-3 bottom-4" data-testid="nav-controls">
            <button
                type="button"
                data-testid="nav-back-btn"
                onClick={() => navigate(-1)}
                title="Go back to the previous page"
                className="w-20 inline-flex items-center justify-center gap-1.5 h-9 bg-[#141414]/90 backdrop-blur-sm border border-[#2a2a2a] text-[#cfcfcf] hover:border-[#ff4500] hover:text-[#ff4500] text-[11px] font-semibold uppercase tracking-[0.2em] shadow-lg transition-colors"
            >
                <ArrowLeft className="h-3.5 w-3.5" /> Back
            </button>
        </div>
    );
}
